import ReactPlayer from 'react-player';
import React from 'react';
import PropTypes from 'prop-types';

const ToolDrawerVideo = ({ videoUrl }) => {
  return <ReactPlayer src={videoUrl} onError={(e) => console.log(e)} width="min-content" height="min-content" />;
};

ToolDrawerVideo.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string
};

export default ToolDrawerVideo;
